<template>
	<div class="nobr">
		<slot></slot>
	</div>
</template>
